import useApi from '../../hooks/api/useApi';
import useMutate from '../../hooks/api/useMutate';

export const NOTIFICATION_BASE_KEY = '/notification';

// GET all notifications

export function useGetNotifications(filters) {
  let query = [];

  if (filters?.page) query.push(`page=${filters.page}`);
  if (filters?.per_page) query.push(`per_page=${filters.per_page}`);

  const queryString = query.length ? `?${query.join('&')}` : '';
  const url = `/notification${queryString}`;

  const { data, error, isLoading, refresh } = useApi(url, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    revalidateIfStale: false
  });

  return {
    notifications: data?.data || [],
    pagination: data?.pagination || {},
    success: data?.success ?? false,
    error,
    isLoading,
    refresh
  };
}

// READ ALL notifications
export function useReadAllNotifications() {
  const { post, isMutating } = useMutate('/notification/read-all');

  const readAll = async () => {
    return await post();
  };

  return {
    readAll,
    isMutating
  };
}

// READ SINGLE notification
export function useReadNotification() {
  const readOne = async (id) => {
    if (!id) throw new Error('Notification ID is required');

    const { post } = useMutate(`/notification/${id}/read`);
    return await post();
  };

  return {
    readOne
  };
}

// DELETE ALL notifications
export function useDeleteAllNotifications() {
  const { delete: deleteRequest } = useMutate('/notification/delete-all');

  const deleteAll = async () => {
    return await deleteRequest();
  };

  return {
    deleteAll
  };
}
